var _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessOnVmSvgrepoComCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "3.1199976 0.09599976 30.528 32.76",
    fill: "#00000",
    style: {
      maxHeight: 500
    },
    width: 30.528,
    height: 32.76,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "process-on-vm-line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-1",
    fill: "#008ace",
    d: "M33.49,26.28a1,1,0,0,0-1.2-.7l-2.49.67a14.23,14.23,0,0,0,2.4-6.75A14.48,14.48,0,0,0,27.37,7.35,1,1,0,0,0,26,7.44a1,1,0,0,0,.09,1.41,12.45,12.45,0,0,1,4.16,10.46,12.19,12.19,0,0,1-2,5.74L28,22.54a1,1,0,1,0-1.95.16l.5,6.44,6.25-1.66A1,1,0,0,0,33.49,26.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-2",
    fill: "#008ace",
    d: "M4.31,17.08a1.06,1.06,0,0,0,.44.16,1,1,0,0,0,1.12-.85A12.21,12.21,0,0,1,18.69,5.84L16.45,7.37a1,1,0,0,0,.47,1.79A1,1,0,0,0,17.56,9l5.33-3.66L18.33.76a1,1,0,1,0-1.39,1.38l1.7,1.7A14.2,14.2,0,0,0,3.89,16.12,1,1,0,0,0,4.31,17.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-3",
    fill: "#008ace",
    d: "M21.73,29.93a12,12,0,0,1-4.84.51,12.3,12.3,0,0,1-9.57-6.3l2.49.93a1,1,0,0,0,.69-1.84l-4.59-1.7h0L4.44,21,3.33,27.35a1,1,0,0,0,.79,1.13l.17,0a1,1,0,0,0,1-.81l.42-2.4a14.3,14.3,0,0,0,11,7.14,13.91,13.91,0,0,0,5.63-.6,1,1,0,0,0-.6-1.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-4",
    fill: "#00b6eb",
    d: "M22,13H14a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Zm-1,8H15V15h6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0,
    height: 36,
    width: 36,
    y: 0,
    x: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessOnVmSvgrepoComCropped);
export default __webpack_public_path__ + "static/media/process-on-vm-svgrepo-com-cropped.7a65d31ff13303ae52517e250767cd49.svg";
export { ForwardRef as ReactComponent };